export const apiRoutes = {
  api_r_user_module_userManagement_getModuleData: {
    path: 'm/user-management/get-module-data/',
  },
  api_r_user_module_userManagement_getPermissions: {
    path: 'm/user-management/get-permissions/',
  },
  api_r_user_module_userManagement_user_selector_add: {
    path: 'm/user-management/user/selector/add/',
  },
  api_r_user_module_userManagement_user_list: {
    path: 'm/user-management/user/list/',
  },
  api_r_user_module_userManagement_user_list_pagination: {
    path: 'm/user-management/user/list/pagination/',
  },
  api_r_user_module_userManagement_loadUserLevel: {
    path: 'm/user-management/load-userLevel/',
  },
  api_r_user_module_userManagement_user_list_select: {
    path: 'm/user-management/user/list/select/',
  },
  api_r_user_module_userManagement_user_get: {
    path: 'm/user-management/user/get/',
  },
  api_r_user_module_userManagement_user_data_list: {
    path: 'm/user-management/user/data/list/',
  },
  api_r_user_module_userManagement_user_modules_list_select: {
    path: 'm/user-management/user/modules/list/select/',
  },
  api_r_user_module_userManagement_user_add: {
    path: 'm/user-management/user/add/',
  },
  api_r_user_module_userManagement_user_edit_get: {
    path: 'm/user-management/user/edit/get/',
  },
  api_r_user_module_userManagement_user_edit: {
    path: 'm/user-management/user/edit/',
  },
  api_r_user_module_userManagement_user_delete: {
    path: 'm/user-management/user/delete/',
  },
  api_r_user_module_userManagement_user_check: {
    path: 'm/user-management/user/check/',
  },
  api_r_user_module_userManagement_user_export_permissions: {
    path: 'm/user-management/user/export/permissions/',
  },
  api_r_user_module_userManagement_userAccessCode_list: {
    path: 'm/user-management/user-access-code/list/',
  },
  api_r_user_module_userManagement_userAccessCode_add: {
    path: 'm/user-management/user-access-code/add/',
  },
  api_r_user_module_userManagement_userAccessCode_delete: {
    path: 'm/user-management/user-access-code/delete/',
  },
  api_r_user_module_userManagement_userAccessCode_generateFilterHexCode: {
    path: 'm/user-management/user-access-code/generate-filter-hex-code/',
  },
  api_r_user_module_userManagement_userAccessCode_getFilters: {
    path: 'm/user-management/user-access-code/get-filters/',
  },
  api_r_user_module_userManagement_userAccessCode_autoclone_list: {
    path: 'm/user-management/user-access-code/autoclone/list/',
  },
};
